'use strict';

/* eslint-disable max-lines-per-function, max-params, max-len */
angular.module('webAgro1App').factory('InfoWindowService', function($rootScope, $compile, $route, $uibModal, filterFilter,
  AtividadesService, ContagensService, MessagesService, ItensService, $filter, RotateImageService, OcorrenciasService, LoadingService) {
  const updateCurrentInfoWindow = function(instance) {
    $rootScope.currentInfoWindow = instance;
    if (!$rootScope.$$phase) {
      $rootScope.$apply();
    }
  };

  return {
    // eslint-disable-next-line complexity
    createInfoWindow: function(templateInfoWindow, marker, objeto, leafletMarker) {
      if (objeto.atividade) {
        const atividade = objeto.atividade.descricao || objeto.atividade;
        objeto.isCorn = AtividadesService.isCorn(atividade);
      }

      if (objeto.produtividade && objeto.isCorn) {
        objeto.cornClassifications = ContagensService.getCornClassifications(objeto.samples);
        objeto.cornMeans = {};
        _.uniq(_.flatMap(objeto.samples, Object.keys)).forEach((k) => {
          objeto.cornMeans[k] = _.chain(objeto.samples)
            .map(`${k}.corns`)
            .map(Number)
            .filter((v) => !isNaN(v))
            .mean()
            .value();
        });
      }

      const _this = this;
      const scope = $rootScope.$new();
      const infoWindow = new google.maps.InfoWindow({
        id: (marker || {}).id
      });
      const leafletPopup = L.popup({
        minWidth: 591,
        maxWidth: 592
      });

      scope.modalInfo = function(template) {
        $uibModal.open({
          templateUrl: template,
          scope: scope
        });
      };

      scope.generateTaskInfoWindow = function(event) {
        event.preventDefault();
        _this.close(infoWindow);
        $rootScope.$broadcast('generateTaskInfoWindow', marker, leafletMarker);
      };

      scope.generateTaskFromOcorrencia = function(event) {
        event.preventDefault();
        _this.close(infoWindow);

        const filteredLeafletMarkers = objeto.allLeafletMarkers.filter(function(m) {
          const praga = _.find(TIPOS_OCORRENCIA, { id: m.objeto.tipo });
          const outrasOcorrencias = TIPOS_OUTRAS_OCORRENCIAS.includes(m.objeto.tipo);
          return m && (praga || outrasOcorrencias);
        }).sort(function(a, b) {
          return moment(a.objeto.createdAt) - moment(b.objeto.createdAt);
        })
          .reduce(function(group, m) {
            if (group.length > 0) {
              if (moment(m.objeto.createdAt).diff(group[group.length - 1].objeto.createdAt, 'seconds') > 5) {
                group.push(m);
              }
            } else {
              group.push(m);
            }
            return group;
          }, []);
        $rootScope.$broadcast('generateTaskFromOcorrencia', filteredLeafletMarkers);
      };

      scope.editOcorrencia = function() {
        _this.close(infoWindow);
        $uibModal.open({
          templateUrl: 'views/propriedade/modal-edit-ocorrencia.html',
          resolve: { objeto },
          controller: 'ModalEditOcorrenciaCtrl',
          controllerAs: '$ctrl',
          windowClass: 'behind-loader'
        }).result.then((result) => {
          if (result) {
            $route.reload();
          }
        });
      };

      scope.editStand = function() {
        _this.close(infoWindow);
        $uibModal.open({
          templateUrl: 'views/propriedade/modal-edit-contagem.html',
          resolve: { objeto },
          controller: 'ModalEditContagemCtrl',
          controllerAs: '$ctrl',
          windowClass: 'behind-loader'
        }).result.then((result) => {
          if (result) {
            $route.reload();
          }
        });
      };

      scope.desativarRegistro = function(event, registro, markerRegister) {
        event.preventDefault();

        let tipoName;
        let action;

        switch (registro.tipo) {
        case 'stand':
          tipoName = 'contagem';
          action = 'contagens/';
          break;
        case 'produtividade':
          tipoName = 'estimativa de produtividade';
          action = 'produtividade_contagens/';
          break;
        default:
          return;
        }

        MessagesService.confirm(`Deseja desativar a ${tipoName} desse ponto?`).then(function() {
          $rootScope.$broadcast('desativarRegistro', registro, markerRegister, action);
        });
      };

      scope.nomeUsuario = function() {
        if (scope.parameter.usuario) {
          return scope.parameter.usuario.nome || scope.parameter.usuario.user_name;
        }

        return scope.parameter.user.user_name;
      };

      scope.canEditCultivar = function(data) {
        let permission = data.tipo;

        if (['stand', 'produtividade'].includes(data.tipo)) {
          permission = 'contagem';
        } else if (['inseto', 'invasora', 'doenca', 'nematoide', 'climatica', 'solo', 'manutencao_melhoria', 'inimigo_natural'].includes(data.tipo)) {
          permission = 'ocorrencia';
        }

        return scope.permissions[permission].canManage;
      };

      scope.changeCultivar = function() {
        MessagesService.confirm('Deseja alterar a cultivar desse ponto?').then(function() {
          $rootScope.$broadcast('changeCultivar', objeto, scope.parameter.cultivarSelected);
          scope.parameter.cultivar = scope.parameter.cultivarSelected.descricao;
          scope.resetCultivares();
        })
          .finally(scope.resetCultivares);
      };

      scope.resetCultivares = function() {
        scope.cultivares = {};
      };

      scope.listCultivares = function() {
        scope.cultivares = {
          loading: true
        };

        const params = {
          safra: (objeto.params || {}).safra_id || (objeto.safra || {}).id,
          gleba: (objeto.params || {}).gleba_id || (objeto.gleba || {}).id
        };

        ItensService.listCultivares(params).then(function(result) {
          scope.cultivares.dados = result.data || [];
          scope.parameter.cultivarSelected = filterFilter(scope.cultivares.dados, { item_id: parseInt(objeto.params.cd_insumo) }, true)[0] || {};
        })
          .finally(function() {
            scope.cultivares.loading = false;
          });
      };

      scope.uniformidadeDistribuicaoColor = function(value) {
        if (value < 5) {
          return 'text-equilibrio';
        }
        if (value < 10) {
          return 'text-controle';
        }
        return 'text-emergencia';
      };

      scope.uniformidadeDistribuicaoChart = function(lines) {
        const result = {
          type: 'ColumnChart',
          data: {
            cols: [
              { label: 'Linha', type: 'string' },
              { label: 'Uniformidade', type: 'number' },
              { label: 'Uniformidade ideal', type: 'number' }
            ]
          },
          options: {
            legend: { position: 'none' },
            height: 200,
            width: Math.max(lines.length * 60, 200),
            vAxis: {
              viewWindow: {
                min: 0
              },
              format: '#.##%'
            },
            hAxis: {
              slantedText: true
            }
          }
        };

        if (google && google.visualization) {
          const array = [
            ['Linha', 'Uniformidade', { role: 'tooltip' }, 'Uniformidade ideal', { role: 'tooltip' }]
          ].concat(lines.map(function(line, index) {
            return [
              `Linha ${ index + 1}`,
              line.uniformidadeDistribuicao / 100,
              `Uniformidade: ${ $filter('number')(line.uniformidadeDistribuicao, 2) }%`,
              (line.coeficienteVariacaoIdeal || 0) / 100,
              `Uniformidade ideal: ${ $filter('number')(line.coeficienteVariacaoIdeal || 0, 2) }%`
            ];
          }));
          result.data = google.visualization.arrayToDataTable(array);
        }

        return result;
      };

      scope.changeToNaoOcorrencia = function(item, registro) {
        MessagesService.confirm(`Deseja realmente marcar ${item.descricao} como "Não há ocorrência"?`).then(function() {
          LoadingService.showLoading();
          OcorrenciasService
            .changeToNaoOcorrencia(registro.sincId, item.id)
            .then(() => {
              $route.reload();
            })
            .catch(() => {
              MessagesService.alert('Ocorreu um erro, por favor tente novamente.');
            })
            .finally(LoadingService.hideLoading);
        });
      };

      scope.rotate = function(image, direction) {
        image.processing = true;
        RotateImageService.rotate(image, direction).then(function(result) {
          image = result;
        }, function(error) {
          console.error('Erro ao rotacionar image', error);
          image.processing = false;
          MessagesService.alert('Ocorreu um erro ao girar a imagem, por favor tente novamente.');
        });
      };

      scope.permissions = $rootScope.permissions;
      scope.marker = marker || leafletMarker;

      scope.customLatLng = function() {
        const modalScope = $rootScope.$new();
        modalScope.custom = {
          latitude: scope.parameter.latitude,
          longitude: scope.parameter.longitude
        };
        const modal = $uibModal.open({
          scope: modalScope,
          templateUrl: 'views/infowindow_templates/custom-latlng.html'
        });
        modal.result.then((result) => {
          const latLng = L.latLng(result.latitude, result.longitude);
          if (scope.marker.circle) {
            scope.marker.circle.setLatLng(latLng);
          }
          scope.marker.setLatLng(latLng);
        });
      };

      if (marker) {
        marker.addListener('click', function() {
          const contentString = compileWindow();
          infoWindow.setContent(contentString[0]);

          marker.isOpen = !marker.isOpen;
          updateCurrentInfoWindow(marker.isOpen ? infoWindow : null);
          if (_this.lastMarker) {
            const sameMarker = _this.lastMarker.id === marker.id;
            if (!sameMarker) {
              _this.lastMarker.isOpen = false;
            }
          }
          _this.lastMarker = marker;

          if (_this.infoWindow) {
            _this.infoWindow.close();
            const same = _this.infoWindow.id === infoWindow.id;
            _this.infoWindow = null;

            if (same) {
              return;
            }
          }

          infoWindow.open(marker.getMap(), marker);
          _this.infoWindow = infoWindow;
        });
      }

      if (leafletMarker) {
        leafletMarker.bindPopup(leafletPopup);
        leafletMarker.on('popupopen', () => {
          leafletPopup.setContent(compileWindow()[0]);
        });
        leafletMarker.on('click', () => {
          $rootScope.$apply();
        });
      }

      google.maps.event.addListener(infoWindow, 'domready', function() {
        const iwOuter = $('.gm-style-iw');
        iwOuter.parent().addClass('gm-container');
        iwOuter.prev().addClass('gm-background-iw');
        iwOuter.next().addClass('gm-close-btn-iw')
          .html('');
      });

      google.maps.event.addListener(infoWindow, 'closeclick', function() {
        marker.isOpen = false;
        _this.lastMarker = null;
        _this.infoWindow = null;
        updateCurrentInfoWindow(null);
      });

      return infoWindow;

      function compileWindow() {
        scope.parameter = objeto;
        scope.parameter.comentario = (marker || leafletMarker || {}).comentario;
        return $compile(templateInfoWindow)(scope);
      }
    },

    close: function(instance) {
      $rootScope.$broadcast('closePopup', instance);
    }
  };
});
